import {FACILITY_CATEGORY} from '../../../CodeMaster'
import FacilityCardInfo from '../../facilities/FacilityCardInfo'
import {
    SearchConditions,
} from './RRFTFacilitySearchComponent'

interface SearchConditionsForJSON {
    categories: string[]
}

export class RRFTFacilitySearchComponentHelper {
    static serializeSearchConditions(searchConditions: SearchConditions): string {
        const {
            categories,
        } = searchConditions
        const searchConditionsForJson: SearchConditionsForJSON = {
            categories: categories.map(category => category.value),
        }
        return JSON.stringify(searchConditionsForJson)
    }

    static deserializeSearchConditions(json: string): SearchConditions {
        const searchConditionsForJson: SearchConditionsForJSON = JSON.parse(json)
        const {
            categories,
        } = searchConditionsForJson
        return {
            categories:
                categories.map(category => FACILITY_CATEGORY.codeToEnumConstants(category)),
        }
    }

    static extractFacilityCategories(facilityCardInfos: FacilityCardInfo[]):FACILITY_CATEGORY[]{
        const categorySet: Set<FACILITY_CATEGORY> = new Set<FACILITY_CATEGORY>()
        facilityCardInfos.forEach(facilityCardInfo => {
            categorySet.add(facilityCardInfo.category)
        })
        return Array.from(categorySet).sort((a, b) => a.displayOrder - b.displayOrder)
    }

    static filterFacilityCardInfosByCategory(
        facilityCardInfos: FacilityCardInfo[],
        condition: SearchConditions,
    ): FacilityCardInfo[] {
        if (condition.categories.length === 0) {
            return facilityCardInfos
        }
        return facilityCardInfos.filter((info) => (
            condition.categories.includes(info.category)
        ))
    }
}
